import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

// Modules Material utilises

// Autres modules externes utilises 

// Modules communs utilises
import { CheckboxListModule } from '../../../shared/checkbox-list/checkbox-list.module';
import { FilterableSelectModule } from '../../../shared/filterable-select/filterable-select.module';

// Modules metier utilises
import { AntenneModule } from '../antenne/antenne.module';
import { ParcModule } from '../parc/parc.module';

// Composants metiers
import { AntenneToOuvragesSelectorComponent } from './components/antenne-to-ouvrages-selector.component';
import { OuvrageBySousParcSelectorComponent } from './components/ouvrage-by-sous-parc-selector.component';
import { OuvrageBySousParcMultiSelectorComponent } from './components/ouvrage-by-sous-parc-multi-selector.component';
import { OuvrageBySousParcMultiSelectorWithNotesComponent } from './components/ouvrage-by-sous-parc-multi-selector-with-notes.component';
import { OuvrageByGroupementMultiSelectorComponent } from './components/ouvrage-by-groupement-multi-selector.component';
import { OuvrageCheckboxListComponent } from './components/ouvrage-checkbox-list.component';

import { JSR310LocalDatesModule } from '../../../shared/jsr310-localdates/jsr310-localdates.module';

// Services metier
import { OuvrageService } from './services/ouvrage.service';

// Bridges avec la partie angular
import * as angular from 'angular';
import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		
		CheckboxListModule,
		FilterableSelectModule,
		
		AntenneModule,
		ParcModule,
		
		JSR310LocalDatesModule,
	],
	providers: [
		OuvrageService,
	],
	declarations: [
		AntenneToOuvragesSelectorComponent,
		OuvrageBySousParcSelectorComponent,
		OuvrageBySousParcMultiSelectorComponent,
		OuvrageBySousParcMultiSelectorWithNotesComponent,
		OuvrageByGroupementMultiSelectorComponent,
		OuvrageCheckboxListComponent,
	],
	exports: [
		AntenneToOuvragesSelectorComponent,
		OuvrageBySousParcSelectorComponent,
		OuvrageBySousParcMultiSelectorComponent,
		OuvrageBySousParcMultiSelectorWithNotesComponent,
		OuvrageByGroupementMultiSelectorComponent,
		OuvrageCheckboxListComponent,
	]
})
export class OuvrageModule {
	constructor() { }
}

angular.module('auroraApp') //
	.directive('ouvrageBySousParcMultiSelector',
		downgradeComponent({ component: OuvrageBySousParcMultiSelectorComponent })
	) //
	.directive('ouvrageBySousParcMultiSelectorWithNotes',
		downgradeComponent({ component: OuvrageBySousParcMultiSelectorWithNotesComponent })
	) //
	.service('ouvragesService',
		downgradeInjectable(OuvrageService)
	) //
;